import { useState, useEffect } from "react";

// True on real desktop/tablet viewports: wide AND tall enough. A phone rotated to
// landscape is wide (>768px) but short (<500px) — we keep the clean mobile layout there
// instead of flipping to the desktop sidebar on a tiny-height screen.
export default function useIsDesktop() {
  const query = "(min-width: 768px) and (min-height: 500px)";
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setIsDesktop(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return isDesktop;
}
